/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { feedsUpdate } from '../../axios/feedsUpdate'
import type {
	FeedsUpdateError,
	FeedsUpdatePathParams,
	FeedsUpdateRequest,
	FeedsUpdateResponse,
} from '../../types/FeedsUpdate'

export const feedsUpdateMutationKey = () => [{ url: '/ad-generation/feeds/:feed' }] as const

export type FeedsUpdateMutationKey = ReturnType<typeof feedsUpdateMutationKey>

export type FeedsUpdateVariables = {
	feed: FeedsUpdatePathParams['feed']
	data: FeedsUpdateRequest
}

/** @see backend/nexus/modules/AdGeneration/Http/Controllers/FeedController.php FeedController::update */
export function useFeedsUpdate<TContext = unknown>(
	options?: UseMutationOptions<FeedsUpdateResponse, AxiosError<FeedsUpdateError>, FeedsUpdateVariables, TContext>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: feedsUpdateMutationKey(),
		mutationFn: ({ feed, data }: FeedsUpdateVariables) => feedsUpdate(feed, data, config).then(res => res.data),
		...options,
	})
}
